export default __webpack_public_path__ + "static/media/product-01 (2).a8fb356d.jpg";